require('./mortagageRequestMonthlyIncomeAndExpenses.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const className = require('classnames');

//@core
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

//@commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { AmountInput } = require('commonsComponents/amountInput');

// @constants
const { HOLDER_OPTION_ONE, HOLDER_OPTION_TWO } = require('constants/mortgageRequestPreApproval').mortgageRequestPreApprovalCommons;
const { EURO_SYMBOL } = require('constants/index');

class MortagageRequestMonthlyIncomeAndExpenses extends React.Component {

    constructor(props) {
        super(props);

        this.handleIncomesHolder = this.handleIncomesHolder.bind(this);
        this.handlerExpensesHolder = this.handlerExpensesHolder.bind(this);
    }

    handleIncomesHolder(value, holder) {
        const incomes = !!value ? parseFloat(value) : value;
        this.props.formHandlers.handleIncomes(incomes, holder);
    }

    handlerExpensesHolder(value, holder) {
        const expenses = !!value ? parseFloat(value) : value;
        this.props.formHandlers.handleExpenses(expenses, holder);
    }

    buildIncomesInput(holder) {
        const { immMortgageRequest, validModal } = this.props;
        const incomesHolder = immMortgageRequest.getIn(['holders', holder, 'incomes']);
        const error = incomesHolder === 0 || (!validModal.get('valid') && !incomesHolder);
        const errorText = formatText('mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_youNeedIncludeIncome');

        return (
            <div className="mortgage-request-monthly-income__input-field">
                <div className="row no-gutter">
                    <div className="col-md-10">
                        <AmountInput
                            amount={incomesHolder}
                            callback={value => this.handleIncomesHolder(value, holder)}
                            min={0}
                            maxBackEndFractionLength={2}
                            keepZeroAndEmpty
                            showBlurZero
                            fluid
                            language={getLanguage()}
                            error={error}
                            errorMsg={errorText}
                        />
                    </div>
                    <div className="col-md-2">
                        <span className="mortgage-request-monthly-income__euro-sign">{EURO_SYMBOL}</span>
                    </div>
                </div>
            </div>
        );
    }

    buildExpensesInput(holder) {
        const { immMortgageRequest } = this.props;
        const expensesHolder = immMortgageRequest.getIn(['holders', holder, 'expenses']);
        let secondHolderDisclaimer;

        if (holder === HOLDER_OPTION_TWO) {
            secondHolderDisclaimer = (
                <div className="mortgage-request-monthly-income__disclaimer">
                    <FormattedText value="mortgageRequestPreApprovalStepThree-monthlyIncomeDisclaimer" />
                </div>
            );
        }

        return (
            <div className="mortgage-request-monthly-income__input-field">
                <div className="row no-gutter">
                    <div className="col-md-10">
                        <AmountInput
                            amount={expensesHolder}
                            callback={value => this.handlerExpensesHolder(value, holder)}
                            min={0}
                            maxBackEndFractionLength={2}
                            keepZeroAndEmpty
                            showBlurZero
                            fluid
                            language={getLanguage()}
                        />
                        {secondHolderDisclaimer}
                    </div>
                    <div className="col-md-2">
                        <span className="mortgage-request-monthly-income__euro-sign">{EURO_SYMBOL}</span>
                    </div>
                </div>
            </div>
        );
    }

    buildHolderOneFields(responsiveMobileVersion) {
        const {
            immMortgageRequest,
            validModal,
        } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const incomesHolder = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, 'incomes']);
        const error = incomesHolder === 0 || (!validModal.get('valid') && !incomesHolder);
        const errorText = formatText('mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_youNeedIncludeIncome');
        const expensesHolder = immMortgageRequest.getIn(['holders', HOLDER_OPTION_ONE, 'expenses']);
        let secondHolderDisclaimer;

        if (HOLDER_OPTION_ONE === HOLDER_OPTION_TWO) {
            secondHolderDisclaimer = (
                <div className="mortgage-request-monthly-income__disclaimer">
                    <FormattedText value="mortgageRequestPreApprovalStepThree-monthlyIncomeDisclaimer" />
                </div>
            );
        }

        const cssContainer = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 ';
        const cssContainerTitle = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 mortgage-request-marital-status-and-dependents__desktopVersionTitleHeight mortgage-request-marital-status-and-dependents__desktopVersionTitle ';

        return (
            <div className="row">
                <div className={cssContainerTitle}  >
                    <div className="mortgage-request-marital-status-and-dependents__label"  >
                        {responsiveMobileVersion && selectedHolder === HOLDER_OPTION_ONE ? null :
                            <FormattedText value="mortgageRequestPreApprovalStepThree-firstOwner" />

                        }
                    </div>

                </div>
                <div className={cssContainer}>
                    <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>
                        <div className="mortgage-request-monthly-income__input-field-title">
                            <FormattedText value="mortgageRequestPreApprovalStepThree-monthlyIncomeTitle1" />
                        </div>
                        <div className="mortgage-request-monthly-income__label">
                            <FormattedText value="mortgageRequestPreApprovalStepThree-monthlyIncomeText1" />
                        </div>
                    </label>
                    <div className="mortgage-request-monthly-income__container-span">

                        <AmountInput
                            amount={incomesHolder}
                            callback={value => this.handleIncomesHolder(value, HOLDER_OPTION_ONE)}
                            min={0}
                            maxBackEndFractionLength={2}
                            keepZeroAndEmpty
                            showBlurZero
                            fluid
                            language={getLanguage()}
                            error={error}
                            errorMsg={errorText}
                        />
                        <span className="mortgage-request-monthly-income__euro-sign">{EURO_SYMBOL}</span>
                    </div>

                </div>
                <div className={cssContainer}>

                    <div class="ok-select">
                        <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>
                            <div className="mortgage-request-monthly-income__input-field-title">
                                <FormattedText value="mortgageRequestPreApprovalStepThree-monthlyIncomeTitle2" />
                            </div>
                            <div className="mortgage-request-monthly-income__label mortgage-request-monthly-income__label-height"  >
                                <FormattedText value="mortgageRequestPreApprovalStepThree-monthlyIncomeText2" />
                            </div>
                        </label>
                    </div>
                    <div className="mortgage-request-monthly-income__container-span">

                        <AmountInput
                            amount={expensesHolder}
                            callback={value => this.handlerExpensesHolder(value, HOLDER_OPTION_ONE)}
                            min={0}
                            maxBackEndFractionLength={2}
                            keepZeroAndEmpty
                            showBlurZero
                            fluid
                            language={getLanguage()}
                        />
                        {secondHolderDisclaimer}

                        <span className="mortgage-request-monthly-income__euro-sign">{EURO_SYMBOL}</span>
                    </div>

                </div>
            </div>
        );
    }
    buildHolderTwoFields(responsiveMobileVersion) {

        const { immMortgageRequest, validModal } = this.props;
        const incomesHolder = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, 'incomes']);
        const error = incomesHolder === 0 || (!validModal.get('valid') && !incomesHolder);
        const errorText = formatText('mortgageRequestPreApprovalStepThree-mortgageRequestPreApprovalStepThree_youNeedIncludeIncome');
        const expensesHolder = immMortgageRequest.getIn(['holders', HOLDER_OPTION_TWO, 'expenses']);
        let secondHolderDisclaimer;

        if (HOLDER_OPTION_TWO === HOLDER_OPTION_TWO) {
            secondHolderDisclaimer = (
                <div className="mortgage-request-monthly-income__disclaimer">
                    <FormattedText value="mortgageRequestPreApprovalStepThree-monthlyIncomeDisclaimer" />
                </div>
            );
        }
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const cssContainer = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 ';
        const cssContainerTitle = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 mortgage-request-marital-status-and-dependents__desktopVersionTitle ';

        return (
            <div className={!responsiveMobileVersion ? 'row mortgage-request-marital-status-and-dependents__margintop-15' : "row"}>
                <div className={cssContainerTitle}>
                    <div className="mortgage-request-marital-status-and-dependents__label"  >
                        {responsiveMobileVersion && selectedHolder === HOLDER_OPTION_ONE ? null :
                            <FormattedText value="mortgageRequestPreApprovalStepThree-secondOwner" />
                        }
                    </div>
                </div>

                <div className={cssContainer}>
                    {responsiveMobileVersion &&
                        <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>
                            <div className="mortgage-request-monthly-income__input-field-title">
                                <FormattedText value="mortgageRequestPreApprovalStepThree-monthlyIncomeTitle1" />
                            </div>
                            <div className="mortgage-request-monthly-income__label">
                                <FormattedText value="mortgageRequestPreApprovalStepThree-monthlyIncomeText1" />
                            </div>
                        </label>
                    }
                    <div className="mortgage-request-monthly-income__container-span">
                        <AmountInput
                            amount={incomesHolder}
                            callback={value => this.handleIncomesHolder(value, HOLDER_OPTION_TWO)}
                            min={0}
                            maxBackEndFractionLength={2}
                            keepZeroAndEmpty
                            showBlurZero
                            fluid
                            language={getLanguage()}
                            error={error}
                            errorMsg={errorText}
                        />

                        <span className="mortgage-request-monthly-income__euro-sign">{EURO_SYMBOL}</span>
                    </div>
                </div>

                <div className={cssContainer}>
                    <div class="ok-select">
                        {responsiveMobileVersion &&
                            <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>
                                <div className="mortgage-request-monthly-income__input-field-title">
                                    <FormattedText value="mortgageRequestPreApprovalStepThree-monthlyIncomeTitle2" />
                                </div>
                                <div className="mortgage-request-monthly-income__label">
                                    <FormattedText value="mortgageRequestPreApprovalStepThree-monthlyIncomeText2" />
                                </div>
                            </label>
                        }

                    </div>
                    <div className="mortgage-request-monthly-income__container-span">
                        <AmountInput
                            amount={expensesHolder}
                            callback={value => this.handlerExpensesHolder(value, HOLDER_OPTION_TWO)}
                            min={0}
                            maxBackEndFractionLength={2}
                            keepZeroAndEmpty
                            showBlurZero
                            fluid
                            language={getLanguage()}
                        />
                        <span className="mortgage-request-monthly-income__euro-sign">{EURO_SYMBOL}</span>
                    </div>
                    <div className="mortgage-request-marital-status-and-dependents__note">
                        <FormattedText value="mortgageRequestPreApprovalStepThree-dependentsNote" />
                    </div>
                </div>
            </div>

        );
    }

    render() {
        const { immMortgageRequest, responsiveMobileVersion } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const customClass = className(
            {
                'col-md-4': selectedHolder !== HOLDER_OPTION_ONE,
                'col-md-6': selectedHolder === HOLDER_OPTION_ONE
            });
    
        const holderOneFields = this.buildHolderOneFields(responsiveMobileVersion);
        const holderTwoFields = selectedHolder === HOLDER_OPTION_ONE ? null : this.buildHolderTwoFields(responsiveMobileVersion);

        let secondHolderTitle, incomesSecondHolderContent, expensesSeondHolderContent;
        let customOffsetClass = 'col-md-offset-6';

        if (selectedHolder === HOLDER_OPTION_TWO) {
            const incomesSecondHolder = this.buildIncomesInput(HOLDER_OPTION_TWO);
            const expensesSeondHolder = this.buildExpensesInput(HOLDER_OPTION_TWO);

            customOffsetClass = 'col-md-offset-4';

            incomesSecondHolderContent = (
                <div className={customClass}>
                    {incomesSecondHolder}
                </div>
            );

            expensesSeondHolderContent = (
                <div className={customClass}>
                    {expensesSeondHolder}
                </div>
            );

            secondHolderTitle = (
                <div className={customClass}>
                    <FormattedText value="mortgageRequestPreApprovalStepThree-secondOwner"
                        className="mortgage-request-monthly-income__input-field-title"
                    />
                </div>
            );
        }

        return (
            <div className="row mortgage-request-marital-status-and-dependents">
                <div className="col-md-11">
                    <OKBoxTitle value={formatText('mortgageRequestPreApprovalStepThree-incomeOutcome')} size="medium" />
                </div>
                <div>
                    <div className='container-fluid'>
                        {holderOneFields}
                        {holderTwoFields}
                    </div>
                </div>
            </div>
        );
    }
}

MortagageRequestMonthlyIncomeAndExpenses.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    formHandlers: PropTypes.object.isRequired,
    validModal: PropTypes.object.isRequired
}

module.exports = MortagageRequestMonthlyIncomeAndExpenses;
